<template>
  <appMeetingGuests
    :meeting-id="meetingId"
    :building-id="buildingId"
    @hideParentActionButtons="$emit('hideParentActionButtons', $event)"
  />
</template>

<script>
import appMeetingGuests from "@/components/snippets/MeetingGuests";

export default {
  components: {
    appMeetingGuests,
  },
  props: {
    meetingId: {
      type: String,
      default: "",
    },
    buildingId: {
      type: String,
      default: "",
    },
  },
};
</script>
